export const GET_UPLODED_LANGUAGE_INIT = 'GET_UPLODED_LANGUAGE_INIT'
export const GET_UPLODED_LANGUAGE_SUCCESS = 'GET_UPLODED_LANGUAGE_SUCCESS'
export const GET_UPLODED_LANGUAGE_ERROR = 'GET_UPLODED_LANGUAGE_ERROR'
